import "./PageBanner.css";

export default function PageBanner({ eyebrow, title, description }) {
  return (
    <section className="page-banner">
      <div className="page-banner__grid grid-texture" aria-hidden="true" />
      <span className="page-banner__ghost" aria-hidden="true">{title}</span>
      <div className="container page-banner__content">
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>
      <div className="forge-divider">
        <svg viewBox="0 0 1200 64" preserveAspectRatio="none">
          <polygon points="0,64 1200,64 1200,0 0,44" fill="var(--bg)" />
        </svg>
      </div>
    </section>
  );
}
